import { render, staticRenderFns } from "./agencyPolicy.vue?vue&type=template&id=08da7744&scoped=true&"
import script from "./agencyPolicy.vue?vue&type=script&lang=js&"
export * from "./agencyPolicy.vue?vue&type=script&lang=js&"
import style0 from "./agencyPolicy.vue?vue&type=style&index=0&id=08da7744&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08da7744",
  null
  
)

export default component.exports